import { useEffect } from "react";
import useLanguage from "../../hooks/useLanguage";

const HtmlLang = () => {
  const { lang } = useLanguage();

  useEffect(() => {
    if (typeof document === "undefined") return;
    if (document.documentElement.lang !== lang) {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  return null;
};

export default HtmlLang;
